import {
    ADMINGETBANKNAMELIST_SUCCESS,
    ADMINGETBANKNAMELIST_FAILED,
    RESET_ADMINGETBANKNAMELIST,
    LOADING_ADMINGETBANKNAMELIST,
    NETWORK_ERROR_ADMINGETBANKNAMELIST
} from "../types/index";
import { adminServices } from "../../config/axios";


const resetAdminGetBankNameList = () => {
    return { type: RESET_ADMINGETBANKNAMELIST };
};

const AdmingetAdminBankLists = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_ADMINGETBANKNAMELIST });
    await adminServices
        .post("getBankNameList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(AdminGetBankNameListsuccess(res.data));
                    break;
                default:
                    dispatch(AdminGetBankNameListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_ADMINGETBANKNAMELIST,
                payload: err
            });
        });
};


function AdminGetBankNameListsuccess(data) {
    return {
        type: ADMINGETBANKNAMELIST_SUCCESS,
        payload: data
    };
}
function AdminGetBankNameListFailed(data) {
    return {
        type: ADMINGETBANKNAMELIST_FAILED,
        payload: data
    };
}

export { AdmingetAdminBankLists, resetAdminGetBankNameList }